import { render, staticRenderFns } from "./FilesComponent.vue?vue&type=template&id=3626af3a&scoped=true&"
import script from "./FilesComponent.vue?vue&type=script&lang=js&"
export * from "./FilesComponent.vue?vue&type=script&lang=js&"
import style0 from "./FilesComponent.vue?vue&type=style&index=0&id=3626af3a&lang=scss&scoped=true&"
import style1 from "./FilesComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3626af3a",
  null
  
)

export default component.exports